import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      redirect: "/dashboard",
      component: () => import("@/view/layout/Layout"),
      children: [
        {
          path: "/dashboard",
          name: "dashboard",
          component: () => import("@/view/pages/Dashboard.vue")
        },
        {
          path: "/profile",
          name: "profile",
          component: () => import("@/view/pages/profile/Profile.vue")
        },
        {
          path: "/profile/sign-ins",
          name: "sign-ins",
          component: () => import("@/view/pages/profile/SignIns.vue")
        },
        {
          path: "/profile/user-tokens",
          name: "user-tokens",
          component: () => import("@/view/pages/profile/UserTokens.vue")
        },
        {
          path: "/profile/api-tokens",
          name: "api-tokens",
          component: () => import("@/view/pages/profile/ApiTokens.vue")
        },
        {
          path: "/devices",
          name: "devices-index",
          component: () => import("@/view/pages/devices/Index.vue")
        },
        {
          path: "/devices/:id",
          name: "devices-show",
          component: () => import("@/view/pages/devices/Show.vue")
        }
      ]
    },
    {
      path: "/admin",
      component: () => import("@/view/layout/Layout"),
      children: [
        {
          path: "/admin/dashboard",
          name: "admin-dashboard",
          component: () => import("@/view/pages/admin/Dashboard.vue")
        },
        {
          path: "/admin/users",
          name: "admin-users-index",
          component: () => import("@/view/pages/admin/users/Index.vue")
        },
        {
          path: "/admin/users/create",
          name: "admin-users-create",
          component: () => import("@/view/pages/admin/users/Create.vue")
        },
        {
          path: "/admin/users/:id",
          name: "admin-users-show",
          component: () => import("@/view/pages/admin/users/Show.vue")
        },
        {
          path: "/admin/users/:id/edit",
          name: "admin-users-edit",
          component: () => import("@/view/pages/admin/users/Edit.vue")
        },
        {
          path: "/admin/devices",
          name: "admin-devices-index",
          component: () => import("@/view/pages/admin/devices/Index.vue")
        },
        {
          path: "/admin/devices/create",
          name: "admin-devices-create",
          component: () => import("@/view/pages/admin/devices/Create.vue")
        },
        {
          path: "/admin/devices/:id",
          name: "admin-devices-show",
          component: () => import("@/view/pages/admin/devices/Show.vue")
        },
        {
          path: "/admin/devices/:id/edit",
          name: "admin-devices-edit",
          component: () => import("@/view/pages/admin/devices/Edit.vue")
        },
        {
          path: "/admin/firmwares",
          name: "admin-firmwares-index",
          component: () => import("@/view/pages/admin/firmwares/Index.vue")
        },
        {
          path: "/admin/firmwares/create",
          name: "admin-firmwares-create",
          component: () => import("@/view/pages/admin/firmwares/Create.vue")
        }
      ]
    },
    {
      path: "/",
      component: () => import("@/view/pages/auth/Otp"),
      children: [
        {
          name: "otp",
          path: "/otp",
          component: () => import("@/view/pages/auth/Otp")
        }
      ]
    },
    {
      path: "/",
      component: () => import("@/view/pages/auth/Login"),
      children: [
        {
          name: "login",
          path: "/login",
          component: () => import("@/view/pages/auth/Login")
        },
        {
          name: "register",
          path: "/register",
          component: () => import("@/view/pages/auth/Login")
        }
      ]
    },
    {
      path: "*",
      redirect: "/404"
    },
    {
      path: "/404",
      name: "404",
      component: () => import("@/view/pages/error/Error-1.vue")
    },
    {
      path: "/403",
      name: "403",
      component: () => import("@/view/pages/error/Error-6.vue")
    }
  ]
});
